if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);

        } else {
          Shopify.onCartUpdate(cart);

        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);

      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}


$('#product-select').on('change', function() {
  console.log( this.value );
  $('.ajax-cart--trigger-add-upsell').data('id', this.value);
});


Shopify.AjaxCart = {

settings: {
  // cartTotalPrice: ,
  vat_rate: 20,
  shippingPrice: 1200,
  shippingPriceDisplay: '$12.00',
  // Threshold is defined in the shop's base currency () subunits.
  // It must be converted to the cart's presentment currency before comparing.
  freeShippingThreshold: 14500,
  shopCurrency: '',
},

	translations: {
		"title": "Bag",
		"cart": {
			"empty_cart": "",
			"loading": "Loading"
		},
		"shipping_banner": {
			"text_required_html": "Spend SHIPPING_PRICE more to get free shipping",
			"text_free_html": "Congrats! You qualify for free shipping.",
			"v2_text_required_html": "Add SHIPPING_PRICE more to your bag.",
			"v2_text_free_html": "You've unlocked FREE SHIPPING on this order."
		},
		"cart_notes": {
			"title": "Order Notes",
			"view_terms": "View terms",
			"agree_to_terms": "I agree with the terms and conditions."
		},
		"statement": {
			"label_shipping": "Shipping",
			"label_savings": "Savings",
			"label_subtotal": "Subtotal",
			"label_total": "Total"
		},
		"buttons": {
			"cart": "TODO",
			"checkout": "Check Out"
		}
	},

	storage: {

		cart: null

	},

	api: {

		addItem: function(options){

			var settings = $.extend({}, options);

			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/cart/add.js',
				type: 'post',
				dataType: 'json',
				data: data,
				beforeSend: function(){
					Shopify.AjaxCart.functions.captureDiscountCodeFromUrl();
					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.add-item.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.add-item.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				success: function (data) {

					Shopify.AjaxCart.api.updateCart();

					$("#ajax-cart").trigger("ajax-cart.add-item.success");

					if (typeof settings.success === 'function') {
						settings.success();
					}

				}
			});

		},

		changeItemQuantity: function(options){

			var settings = $.extend({}, options)

			var quantity = settings.quantity;
			var id = settings.id;

			var data = {
				quantity: quantity,
				id: id
			};

			$.ajax({
				url: '/cart/change.js',
				dataType: 'json',
				cache: false,
				type: 'post',
				data: data,
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.change-item.error", [data]);

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				beforeSend: function(){
					Shopify.AjaxCart.functions.captureDiscountCodeFromUrl();
					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.change-item.before", [data]);

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				success: function (data) {

					Shopify.AjaxCart.api.updateCart();

					$("#ajax-cart").trigger("ajax-cart.change-item.success", [data]);

					if (typeof settings.success === 'function') {
						settings.success();
					}

				}
			});

		},

		updateCart: function(options){

			var settings = $.extend({}, options)

			$.ajax({
				url: '/cart.js',
				dataType: "json",
				cache: false,
				error: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					$("#ajax-cart").trigger("ajax-cart.update-cart.error");

					if (typeof settings.error === 'function') {
						settings.error();
					}

				},
				beforeSend: function(){

					Shopify.AjaxCart.functions.cartOverlayShow();

					$("#ajax-cart").trigger("ajax-cart.update-cart.before");

					if (typeof settings.beforeSend === 'function') {
						settings.beforeSend();
					}

				},
				complete: function(){

					Shopify.AjaxCart.functions.cartOverlayHide();

					if (typeof settings.complete === 'function') {
						settings.complete();
					}

				},
				success: function(data){

                  	Shopify.getCart(function(data){

                      Shopify.AjaxCart.storage.cart = data;
                      Shopify.AjaxCart.functions.refreshShipping();
                      Shopify.AjaxCart.functions.refreshCart();
                      Shopify.AjaxCart.functions.refreshTotals();

                      $("#ajax-cart").trigger("ajax-cart.update-cart.success", [data]);

                      if (typeof settings.success === 'function') {
                          settings.success(data);
                      }

                    });

				}
			});

		}

	},

	templates: {

		cartItem: function(data){

			///console.log(data);

			var id = data.id;
			var image = data.image;
			var title = data.product_title;
			var price = data.price;
			var price_formatted = Shopify.formatMoney(price, $('form').data('money-format'));

			var quantity = data.quantity;
			var url = data.url;
			var variants = data.variant_options;

			var html = "";

			html +=  '<div class="ajax-cart-item" data-id="' + id + '">';
			html +=    '<div class="ajax-cart-item__image">';

			if (image) {
			html +=        '<a href="' + url + '">';
			html +=          '<img src="' + image + '" alt="' + title + '"/>';
			html +=        '</a>';
			}

			html +=    '</div>';

			html +=    '<div class="ajax-cart-item__properties">';
			html +=      '<a class="ajax-cart-item__link" href="' + url + '">';
			html +=        '<div class="ajax-cart-item__title">' + title + '</div>';
			html +=      '</a>';
			html += '<span class="ajax-cart-item__price">';

					var moneyFormat = Shopify.AjaxCart.moneyFormat || $('form').data('money-format');

					// Format values
					// Use per-unit prices, and fall back to discount_allocations if needed
var unitOriginal = (typeof data.original_price === 'number') ? data.original_price : data.price;
var unitFinal    = (typeof data.final_price === 'number') ? data.final_price : data.price;

// If Shopify didn't bake discount into final_price (common with cart-level codes),
// compute unitFinal from discount_allocations
if (unitFinal === unitOriginal && Array.isArray(data.discount_allocations) && data.discount_allocations.length) {
  var allocTotal = 0;
  data.discount_allocations.forEach(function(a){
    allocTotal += parseInt(a.amount, 10) || 0;
  });
  var perUnitAlloc = data.quantity ? Math.round(allocTotal / data.quantity) : allocTotal;
  unitFinal = Math.max(0, unitOriginal - perUnitAlloc);
}

var hasDiscount = unitFinal < unitOriginal;

if (hasDiscount) {
  html += '<span class="money sale_price">' + Shopify.formatMoney(unitFinal, moneyFormat) + '</span>';
  html += '<span class="money was_price">'  + Shopify.formatMoney(unitOriginal, moneyFormat) + '</span>';
} else {
  html += '<span class="money">' + Shopify.formatMoney(unitOriginal, moneyFormat) + '</span>';
}

					html += '</span>';
			html +=      '<div class="ajax-cart-item__variants">';

			if (variants[0] !== "Default Title") {
				for (var i = 0; i < variants.length; i++) {
					if (i === variants.length - 1) {
        			html += variants[i];
    			} else {
							html += variants[i] + ' | ';
					}
				}
			}

			/*
			html +=          '';
			html +=            '';
			html +=          '';
			html +=          '';
			*/
			html +=      '<span tabindex="0" class="ajax-cart-item__remove"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></span></div>';
			html +=      '<div class="ajax-cart-quantity-selector">';
			html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__decrement"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></span>';
			html +=        '<input class="quantity__input ajax-cart-quantity-selector__quantity" type="number" min="0" size="2" name="updates[]" id="updates_' + id + '" value="' + quantity + '" data-line-id=""/>';
			html +=        '<span class="ajax-cart-quantity-selector__button ajax-cart-quantity-selector__increment"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></span>';
			html +=      '</div>';
			html +=    '</div>';
			html +=  '</div>';

			return html;

		},

		cartEmptyMessage: function(){

			var html = "";

			html += '<div class="ajax-cart-empty-message">';
			html +=   '<span class="ajax-cart-empty-message__icon"></span>';
			html +=   '<span class="ajax-cart-empty-message__text">' + Shopify.AjaxCart.translations.cart.empty_cart + '</span>';
			html += '</div>';

			return html;

		},

		cartContentsOverlay: function(options){

			var text = Shopify.AjaxCart.translations.cart.loading;

			if (typeof options != "undefined") {
				if (typeof options.text === "string") {
					text = options.text;
				}
			}

			var html = "";

			html +=  '<div class="ajax-cart-contents-overlay">';
			html +=    '<div class="ajax-cart-contents-overlay__content">';
				html += '<div class="ajax-cart-contents-overlay__icon animation--pulse"><img class="d-none" src="//losangelesapparel.net/cdn/shop/t/206/assets/ajax-cart-loading.svg?v=84242296345956001421783083719" alt="Loading..." /></div>';
			// html +=      '<div class="ajax-cart-contents-overlay__text">Loading...</div>';
			html +=    '</div>';
			html +=  '</div>';

			return html;

		},

	},

	functions: {

		// Returns the free-shipping threshold in the cart's *presentment* currency.
		// cart.total_price comes back from /cart.js already converted to the customer's
		// currency (e.g. RSD), but the configured threshold is in the shop currency (USD).
		// Without converting, a 3.000 RSD item (300000 subunits) instantly clears a raw
		// 14500 threshold and wrongly reports free shipping. Uses Shopify's currencies.js
		// rates (same source the checkout uses) and falls back to the base value.
		// Shop (base) currency. NOTE:  renders EMPTY inside this .js.liquid
		// asset, so read it from the snippet's data-shop-currency (rendered in full page
		// context) and fall back to USD.
		getShopCurrency: function(){
			var fromDom = $('.ajax-cart__form').data('shop-currency');
			var fromSettings = Shopify.AjaxCart.settings.shopCurrency;
			return fromDom || fromSettings || 'USD';
		},

		getShippingThreshold: function(){
			var base = Shopify.AjaxCart.settings.freeShippingThreshold;
			var cart = Shopify.AjaxCart.storage.cart || {};
			var shopCurrency = Shopify.AjaxCart.functions.getShopCurrency();

			// Presentment currency: from /cart.js and from the (market-aware) snippet.
			// Prefer whichever reports a real non-shop currency (handles empty carts whose
			// /cart.js can momentarily report the shop currency).
			var liveCurrency = cart.currency;
			var domCurrency = $('.ajax-cart__form').data('presentment-currency');
			var cartCurrency = (liveCurrency && liveCurrency !== shopCurrency) ? liveCurrency
				: (domCurrency && domCurrency !== shopCurrency) ? domCurrency
				: (liveCurrency || domCurrency || shopCurrency);

			if (!cartCurrency || cartCurrency === shopCurrency) {
				return base;
			}

			// Use the store's own rate table (fetched + cached, see ensureCurrencyRates).
			// We do the math ourselves rather than calling a global Currency.convert(),
			// because other apps on the page can install their own Currency object with
			// different rate semantics. Formula matches Shopify's currencies.js:
			//   amount_in_to = amount * rates[from] / rates[to]
			var rates = Shopify.AjaxCart._fxRates;
			if (rates && rates[cartCurrency] && rates[shopCurrency]) {
				var fromRate = parseFloat(rates[shopCurrency]);
				var toRate = parseFloat(rates[cartCurrency]);
				if (fromRate && toRate) {
					var converted = base * fromRate / toRate;
					if (converted && !isNaN(converted)) {
						return Math.round(converted);
					}
				}
			}

			// Rates not loaded yet — fetch them; the banner/totals re-render once they arrive.
			Shopify.AjaxCart.functions.ensureCurrencyRates();
			return base;
		},

		// Ensures the store's own currency rate table is available (/services/javascripts/
		// currencies.js — the same source the checkout uses), caches it, then re-renders the
		// shipping banner/totals so the converted amount replaces the un-converted fallback.
		// We only read .rates and do the math ourselves (see getShippingThreshold) so a
		// conflicting Currency.convert from another app can't corrupt the result.
		ensureCurrencyRates: function(){
			if (Shopify.AjaxCart._fxRates || Shopify.AjaxCart._fxLoading) { return; }

			var shopCur = Shopify.AjaxCart.functions.getShopCurrency();
			var apply = function(rates){
				Shopify.AjaxCart._fxLoading = false;
				if (!rates || !rates[shopCur]) { return; }
				Shopify.AjaxCart._fxRates = rates;
				try {
					if (Shopify.AjaxCart.storage.cart) {
						Shopify.AjaxCart.functions.refreshShipping();
						Shopify.AjaxCart.functions.refreshTotals();
					}
				} catch (e) {}
			};

			// Fast path: a Shopify currencies.js is already on the page with a usable table.
			if (typeof Currency !== 'undefined' && Currency && Currency.rates && Currency.rates[shopCur]) {
				apply(Currency.rates);
				return;
			}

			Shopify.AjaxCart._fxLoading = true;
			var sc = document.createElement('script');
			sc.src = '/services/javascripts/currencies.js';
			sc.async = true;
			sc.onload = function(){
				apply((typeof Currency !== 'undefined' && Currency) ? Currency.rates : null);
			};
			sc.onerror = function(){
				Shopify.AjaxCart._fxLoading = false;
				if (window.console && console.warn) {
					console.warn('[ajax-cart] could not load /services/javascripts/currencies.js');
				}
			};
			document.head.appendChild(sc);
		},

		cartToggle: function(e){

			var open = $('.ajax-cart').hasClass('ajax-cart--opened') === true;

			if (open === true) {
				Shopify.AjaxCart.eventHandlers.cartClose();
			}
			else {
				Shopify.AjaxCart.eventHandlers.cartOpen();
			}

		},

		cartOpen: function(e){

			$(".ajax-cart")
				.addClass('ajax-cart--opened')
				.removeClass('ajax-cart--closed');

			$(".ajax-cart-overlay").fadeIn();

			$("#ajax-cart").trigger("ajax-cart.cart-open");

			// A/B test activation trigger: fire a custom event to Intelligems 
			try {
				window.igEvents = window.igEvents || [];
				window.igEvents.push({ event: 'cart_opened' });
			} catch (e) {}

			
			$("body").addClass("ajax-cart--lock-scroll");

			// Add the tracking code here
    	fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            if (typeof Shopify !== 'undefined' && Shopify.analytics && Shopify.analytics.publish) {
                Shopify.analytics.publish("custom_cart_viewed", { data: cart });
				
            }
        })
        .catch(error => {
            console.error('Error fetching cart for analytics:', error);
        });


		},

		cartClose: function(){

			$(".ajax-cart")
				.removeClass('ajax-cart--opened')
				.addClass('ajax-cart--closed');

			$(".ajax-cart-overlay").fadeOut();

			$("#ajax-cart").trigger("ajax-cart.cart-close");

			$("body").removeClass("ajax-cart--lock-scroll");

		},

		cartOverlayShow: function(){

			if ( $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay').length > 0 ) {
				return;
			}

			var overlay = Shopify.AjaxCart.templates.cartContentsOverlay({ text: "Cart Loading..." });
			var container = $('.ajax-cart .ajax-cart__body');

			overlay = $(overlay)[0];

			container.prepend(overlay);

		},

		cartOverlayHide: function(){

			var overlay = $('.ajax-cart .ajax-cart__body .ajax-cart-contents-overlay');

			$(overlay).remove();

		},

		// ---- A/B test: shipping banner (control = original, variant = new dark card) ----
		// Sticky 50/50 assignment kept in localStorage so a visitor always sees the same
		// version, then surfaced to the cart drawer (CSS toggles which banner shows) and
		// pushed to dataLayer so conversions can be segmented by variant in GA4 / GTM.
		AB_TEST_KEY: 'la_ab_shipping_banner',

		// Manually force a variant (for QA / testing). Call from the console:
		//   Shopify.AjaxCart.functions.setABTestVariant('variant')  // or 'control'
		// The watcher (watchABTestVariant) re-applies it live, no reload needed.
		setABTestVariant: function(variant){
			if (variant !== 'control' && variant !== 'variant') { return null; }
			try { window.localStorage.setItem(Shopify.AjaxCart.functions.AB_TEST_KEY, variant); } catch (e) {}
			Shopify.AjaxCart.functions.applyABTestVariant();
			return variant;
		},

		getABTestVariant: function(){
			var KEY = Shopify.AjaxCart.functions.AB_TEST_KEY;
			var variant = null;
			try { variant = window.localStorage.getItem(KEY); } catch (e) {}
			if (variant !== 'control' && variant !== 'variant') {
				variant = (Math.random() < 0.5) ? 'control' : 'variant';
				try { window.localStorage.setItem(KEY, variant); } catch (e) {}
			}
			return variant;
		},

		// Tracks the last variant we pushed a class/dataLayer event for, so the
		// watcher only reacts (and only fires analytics) when it actually changes.
		_abTestApplied: null,

		applyABTestVariant: function(){
			var variant = Shopify.AjaxCart.functions.getABTestVariant();
			$('#ajax-cart')
				.removeClass('ajax-cart--ab-control ajax-cart--ab-variant')
				.addClass(variant === 'variant' ? 'ajax-cart--ab-variant' : 'ajax-cart--ab-control');

			// Only report the assignment when it changes, so manual overrides /
			// the polling watcher don't spam dataLayer every tick.
			if (variant !== Shopify.AjaxCart.functions._abTestApplied) {
				Shopify.AjaxCart.functions._abTestApplied = variant;
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'ab_assignment',
					ab_test: 'cart_shipping_banner',
					ab_variant: variant
				});
			}
		},

		// Poll localStorage so a manually-set variant (from the console or another
		// tab) is picked up live without a reload. Guarded so it only starts once,
		// and auto-stops after ~7s so it doesn't poll forever in the background.
		watchABTestVariant: function(){
			if (Shopify.AjaxCart.functions._abTestWatcher) { return; }
			var ticks = 0;
			Shopify.AjaxCart.functions._abTestWatcher = window.setInterval(function(){
				var current = null;
				try { current = window.localStorage.getItem(Shopify.AjaxCart.functions.AB_TEST_KEY); } catch (e) {}
				if (current !== Shopify.AjaxCart.functions._abTestApplied) {
					Shopify.AjaxCart.functions.applyABTestVariant();
				}
				// Stop after 7 ticks (~7s).
				if (++ticks >= 7) {
					window.clearInterval(Shopify.AjaxCart.functions._abTestWatcher);
					Shopify.AjaxCart.functions._abTestWatcher = null;
				}
			}, 1000);
		},

		refreshShipping: function(){
			
			var enableFreeShipping = true;
			
			var freeShippingThreshold = Shopify.AjaxCart.functions.getShippingThreshold();
			var freeShipping = (Shopify.AjaxCart.storage.cart.total_price >= freeShippingThreshold && enableFreeShipping === true) ? true : false;
			var translations = Shopify.AjaxCart.translations.shipping_banner;
			var shippingBannerText;   // control (A)
			var shippingBannerTextV2; // variant (B)

			// Amount still needed to reach the threshold, in the buyer's presentment currency.
			var moneyFormat = $('form').data('money-format');
			var shippingPriceDifference = freeShippingThreshold - Shopify.AjaxCart.storage.cart.total_price;
			// Pass the (presentment) money format so the symbol matches the site currency (e.g. RSD), not $.
			var shippingPriceDifferenceDisplay = Shopify.formatMoney(shippingPriceDifference, moneyFormat);

			if (freeShipping === true) {

				$('.ajax-cart-banner').addClass('ajax-cart-banner--success');
				$('.ajax-cart-banner-v2').addClass('ajax-cart-banner-v2--success');

				shippingBannerText = translations.text_free_html;
				shippingBannerTextV2 = translations.v2_text_free_html;

			}
			else {

				$('.ajax-cart-banner').removeClass('ajax-cart-banner--success');
				$('.ajax-cart-banner-v2').removeClass('ajax-cart-banner-v2--success');

				shippingBannerText = translations.text_required_html.replace("SHIPPING_PRICE", shippingPriceDifferenceDisplay);
				shippingBannerTextV2 = translations.v2_text_required_html.replace("SHIPPING_PRICE", shippingPriceDifferenceDisplay);

			}

			$('.ajax-cart-banner__text').html(shippingBannerText);
			$('.ajax-cart-banner-v2__text').html(shippingBannerTextV2);

		},

		refreshCart: function(){

			var cartCount = Shopify.AjaxCart.storage.cart.item_count;
			var cartItems = Shopify.AjaxCart.storage.cart.items;
			var cartContainer = $('.ajax-cart__items');

			if (cartItems.length > 0) {
				showCartItems();
			}
			else {
				showEmptyMessage();
			}

			$('[data-ajaxcart-value]').text(cartCount);
			$('.cart-count-bubble').text(cartCount);
			function showEmptyMessage() {

				var html = Shopify.AjaxCart.templates.cartEmptyMessage();

				cartContainer.html(html);

			}

			function showCartItems() {

				var html = "";

				for (var i = 0; i < cartItems.length; i++) {
					html += Shopify.AjaxCart.templates.cartItem(cartItems[i]);
				}

				cartContainer.html(html);

			}

		},
		captureDiscountCodeFromUrl: function(){
			try {
			  var code = '';
		  
			  // /discount/CODE
			  var path = window.location.pathname || '';
			  var m = path.match(/\/discount\/([^\/\?]+)/i);
			  if (m && m[1]) code = decodeURIComponent(m[1]).trim();
		  
			  // ?discount=CODE (fallback)
			  if (!code && window.location.search) {
				var params = new URLSearchParams(window.location.search);
				var q = params.get('discount');
				if (q) code = decodeURIComponent(q).trim();
			  }
		  
			  if (code) localStorage.setItem('ajaxcart_discount_code', code);
			} catch(e) {}
		  },
		  
		  getStoredDiscountCode: function(){
			try {
			  return localStorage.getItem('ajaxcart_discount_code') || '';
			} catch(e) {
			  return '';
			}
		  },		  

		  refreshTotals: function(){

			var moneyFormat = $('form').data('money-format');
		  
			
			var enableFreeShipping = true;
			
		  
			var cart = Shopify.AjaxCart.storage.cart;
		  
			var shippingIsFree = (cart.total_price >= Shopify.AjaxCart.functions.getShippingThreshold() && enableFreeShipping === true) ? true : false;
			var shippingPriceLabel = '';
		  
			var lineShipping = $('.ajax-cart-statement-line--shipping .ajax-cart-statement-line__value');
			var lineSavingsRow = $('.ajax-cart-statement-line--savings'); // whole row
			var lineSavingsVal = $('.ajax-cart-statement-line--savings .ajax-cart-statement-line__value');
			var lineVat = $('.ajax-cart-statement-line--vat .ajax-cart-statement-line__value');
			var lineSubtotal = $('.ajax-cart-statement-line--subtotal .ajax-cart-statement-line__value');
			var lineTotal = $('.ajax-cart-statement-line--total .ajax-cart-statement-line__value');
		  
			// SHIPPING
			var valueShipping = (shippingIsFree === true || shippingPriceLabel !== "") ? 0 : Shopify.AjaxCart.settings.shippingPrice;
			var valueShippingDisplay = Shopify.AjaxCart.settings.shippingPriceDisplay;
		  
			// SUBTOTALS
			// original_total_price = before discounts; total_price = after discounts
			var originalSubtotal = (typeof cart.original_total_price === 'number')
			  ? cart.original_total_price
			  : (cart.total_price + (cart.total_discount || 0));
		  
			var discountedSubtotal = cart.total_price;
		  
			// discount amount (fallback to allocations if needed)
			var totalDiscount = (typeof cart.total_discount === 'number')
			  ? cart.total_discount
			  : Math.max(0, originalSubtotal - discountedSubtotal);
		  
			var allocDiscountTotal = 0;
			if (Array.isArray(cart.items)) {
			  cart.items.forEach(function(item){
				(item.discount_allocations || []).forEach(function(da){
				  allocDiscountTotal += (parseInt(da.amount, 10) || 0);
				});
			  });
			}
		  
			var effectiveDiscount = totalDiscount > 0 ? totalDiscount : allocDiscountTotal;
		  
			// VAT (same behavior you had: VAT on discounted subtotal)
			var vatRate = Shopify.AjaxCart.settings.vat_rate || 0;
			var valueVat = (discountedSubtotal * (vatRate / 100));
		  
			// TOTAL
			var valueTotal = discountedSubtotal + valueShipping + valueVat;
		  
			// DISPLAY
			lineSubtotal.html(Shopify.formatMoney(originalSubtotal, moneyFormat));
			lineVat.html(Shopify.formatMoney(valueVat, moneyFormat));
			lineTotal.html(Shopify.formatMoney(valueTotal, moneyFormat));
		  
			// Shipping display
			var displayShipping;
			if (shippingPriceLabel != "") {
			  displayShipping = '<span class="ajax-cart-statement-line__shipping-label">' + shippingPriceLabel + '</span>';
			} else if (shippingIsFree === true || valueShipping === 0) {
			  displayShipping = '<span class="ajax-cart-statement-line__free-shipping">Free</span>';
			} else if (valueShipping > 0) {
			  displayShipping = '<span class="ajax-cart-statement-line__shipping-price">' + valueShippingDisplay + '</span>';
			} else {
			  displayShipping = '';
			}
			lineShipping.html(displayShipping);
		  
			// ---- Discount Title/Code Lines ----
			var $discountLines = $('.ajax-cart-discount-lines');
			if ($discountLines.length) $discountLines.empty();
		  
			function escapeHtml(str){
			  return String(str)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;');
			}
		  
			function renderDiscountRow(label, amountCents){
			  var amountFormatted = Shopify.formatMoney(amountCents, moneyFormat);
			  return (
				'<div class="ajax-cart-statement-line ajax-cart-statement-line--discount">' +
				  '<span class="ajax-cart-statement-line__label">' +
					escapeHtml(label) +
				  '</span>' +
				  '<span class="ajax-cart-statement-line__value">-' + amountFormatted + '</span>' +
				'</div>'
			  );
			}
		  
			var rendered = false;
		  
			// Preferred: use cart.discount_applications if your /cart.js includes it
			if ($discountLines.length && Array.isArray(cart.discount_applications) && cart.discount_applications.length) {
			  var totalsByIndex = {};
			  (cart.items || []).forEach(function(item){
				(item.discount_allocations || []).forEach(function(da){
				  var idx = da.discount_application_index;
				  var amt = parseInt(da.amount, 10) || 0;
				  totalsByIndex[idx] = (totalsByIndex[idx] || 0) + amt;
				});
			  });
		  
			  cart.discount_applications.forEach(function(app, idx){
				var amt = totalsByIndex[idx] || 0;
				if (amt > 0) {
				  $discountLines.append(renderDiscountRow(app.title || 'Discount', amt));
				  rendered = true;
				}
			  });
			}
		  
			// Fallback: show stored code or generic label
			if ($discountLines.length && !rendered && effectiveDiscount > 0) {
			  var storedCode = Shopify.AjaxCart.functions.getStoredDiscountCode
				? Shopify.AjaxCart.functions.getStoredDiscountCode()
				: '';
			  $discountLines.append(renderDiscountRow(storedCode || 'Discount', effectiveDiscount));
			  rendered = true;
			}
		  
			if ($discountLines.length) {
			  if (rendered) {
				$discountLines.show();
				// hide old "Savings" row to avoid duplicates
				lineSavingsRow.hide();
			  } else {
				$discountLines.hide();
				lineSavingsRow.show();
				lineSavingsVal.html(Shopify.formatMoney(effectiveDiscount, moneyFormat));
			  }
			} else {
			  // If you didn't add the container in Liquid, at least keep savings accurate
			  lineSavingsVal.html(Shopify.formatMoney(effectiveDiscount, moneyFormat));
			}
		  },
		  

		addEventListeners: function() {

			$('.ajax-cart__items').on("click", '.ajax-cart-item__remove', Shopify.AjaxCart.eventHandlers.itemRemove);
			$('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__increment', Shopify.AjaxCart.eventHandlers.onClickItemIncrement);
			$('.ajax-cart__items').on("click", '.ajax-cart-quantity-selector__decrement', Shopify.AjaxCart.eventHandlers.onClickItemDecrement);
			$('.ajax-cart__items').on("change", '.ajax-cart-quantity-selector__quantity', Shopify.AjaxCart.eventHandlers.onChangeItemQuantity);

			$('body').on("click", ".ajax-cart-overlay", Shopify.AjaxCart.eventHandlers.onClickCartClose);

			$('body').on('click', '.ajax-cart--trigger-open', Shopify.AjaxCart.eventHandlers.onClickCartOpen);
			$('body').on('click', '.ajax-cart--trigger-close', Shopify.AjaxCart.eventHandlers.onClickCartClose);
			$('body').on('click', '.ajax-cart--trigger-toggle', Shopify.AjaxCart.eventHandlers.onClickCartToggle);
			$('body').on("click", '.ajax-cart--trigger-submit', Shopify.AjaxCart.eventHandlers.onClickCheckout);
			$('body').on("click", '.ajax-cart--trigger-gotocart', Shopify.AjaxCart.eventHandlers.onClickGoToCart);
			$('body').on("click", '.ajax-cart--trigger-add-upsell', Shopify.AjaxCart.eventHandlers.onClickAddUpsell);

		}

	},

	eventHandlers: {

		onClickGoToCart: function(){
			location.href = '/cart';
		},

		onClickCheckout: function(e){

			e.preventDefault();

			$('.ajax-cart__form').submit();

		},

		onClickCartOpen: function(e){

			e.preventDefault();

			if ( $("body").hasClass("cart") === true ) {
				return;
			}

			Shopify.AjaxCart.functions.cartOpen();

		},

		onClickCartClose: function(e){

			e.preventDefault();
			Shopify.AjaxCart.functions.cartClose();

		},

		onClickCartToggle: function(e){

			e.preventDefault();
			Shopify.AjaxCart.functions.cartToggle();

		},

		onClickAddUpsell: function(e){

			var button = $(e.currentTarget);
			var upsell = button.closest(".ajax-cart-upsell__plus");
			var id = upsell.data("id");
      console.log(upsell);
			var options = {
				id: id,
				quantity: 1,
			};

			Shopify.AjaxCart.api.addItem(options);

		},

		onClickItemIncrement: function(e){

			var button = $(e.currentTarget);
			var selector = button.closest('.ajax-cart-quantity-selector');
			var input = selector.find('.ajax-cart-quantity-selector__quantity');
			var value = input.val();

			value++;
			input.val(value);

			input.trigger("change");

		},

		onClickItemDecrement: function(e){

			var button = $(e.currentTarget);
			var selector = button.closest('.ajax-cart-quantity-selector');
			var input = selector.find('.ajax-cart-quantity-selector__quantity');
			var value = input.val();

			value--;
			input.val(value);

			input.trigger("change");

			if (value === 0) {
				setTimeout(() => { frenzyAsyncItems(); }, 200);
			}

		},

		onChangeItemQuantity: function(e){

			var input = $(e.currentTarget);
			var item = input.closest(".ajax-cart-item");
			var id = item.data("id");
			var quantity = input.val();

			Shopify.AjaxCart.api.changeItemQuantity({
				id: id,
				quantity: quantity
			});

		},

		itemRemove: function(e){

			var input = $(e.currentTarget);
			var item = input.closest(".ajax-cart-item");
			var id = item.data("id");
			var quantity = input.val();

			Shopify.AjaxCart.api.changeItemQuantity({
				id: id,
				quantity: 0
			});
			setTimeout(() => { frenzyAsyncItems(); }, 200);

		}

	},

	init: function(){
		Shopify.AjaxCart.functions.captureDiscountCodeFromUrl(); // ✅ add
		Shopify.AjaxCart.functions.applyABTestVariant(); // assign + apply shipping-banner A/B variant
		Shopify.AjaxCart.functions.watchABTestVariant(); // re-apply live if localStorage changes
		Shopify.AjaxCart.functions.addEventListeners();
		Shopify.AjaxCart.api.updateCart();
		// Preload Shopify's currency rates so the free-shipping threshold can be
		// converted to the buyer's presentment currency (e.g. RSD) as early as possible.
		Shopify.AjaxCart.functions.ensureCurrencyRates();
	  }

};

Shopify.AjaxCart.init();
